import { Component, OnInit } from '@angular/core';
// import { GlobalProvider } from 'src/app/services/tabmenu.service';
import { UserService } from 'src/app/services/user.service';
import { ActivatedRoute, Router } from '@angular/router';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  currentYear = new Date().getFullYear();
  appVersion: any;
  flag = 'homepage';
  constructor(  private userService: UserService, private router: Router,) { }

  ngOnInit(): void {

    // this.getAppVersion(true);
  }

  getAppVersion(refresh: any) {
    this.userService.getAppVersion(3, true).subscribe(result => {
      if (result) {
        this.appVersion = result;
      }
      });
    }
    goToHome() {
      // if(this.showfab==true){
      //   this.showfab=false
      // }
    }
    tabButtonClicked(tabNumber: string) {
      this.flag = tabNumber;
  console.log(this.flag);
  
    }
    goToProfile(){
      this.router.navigate(['/freeride']);

    }
}
